import React, { useCallback } from 'react';
import { useClickStreamContext } from './context';
interface LogClickProps {
  cd1?: string;
  cd2?: string;
  cd3?: string;
  eventSource?: string;
  eventInfo: string;
  eventType: string;
  isDisable?: boolean;
}

const LogClick = ({
  cd1,
  cd2,
  cd3,
  eventSource,
  eventInfo,
  eventType,
  isDisable,
  children,
  ...props
}: React.PropsWithChildren<LogClickProps>) => {
  const context = useClickStreamContext();
  const onClick = useCallback(
    (e: React.MouseEvent) => {
      !isDisable && context.logPageEvent?.({ eventSource, eventInfo, eventType, cd1, cd2, cd3 });
      React.isValidElement(children) && children?.props?.onClick?.(e);
    },
    [cd1, cd2, cd3, context, eventInfo, eventSource, isDisable, children, eventType],
  );

  return React.isValidElement(children) ? React.cloneElement<any>(children, { onClick, ...props }) : <>{children}</>;
};

LogClick.displayName = 'LogClick';
export default LogClick;
